<template>
  <div :class="$style['wrapper']">
    <div :class="$style['header']">
      <slot name="header"/>
    </div>
    <div :class="[$style['dropbox'], fileInside ? $style['dropbox--active'] : []]">
      <input
        :name="name"
        :multiple="multiple"
        :class="$style['input-file']"
        type="file"
        @change="onChange"
        @dragenter="onDragEnter"
        @dragleave="onDragLeave"
      >
      <div
        v-if="selectedFiles.length > 0"
        :class="$style['file-selected-wrapper']"
      >
        <div
          v-for="(file, index) in selectedFiles"
          :key="index"
        >
          {{ file.name }}
        </div>
      </div>
      <div
        v-else
        :class="$style['no-file-wrapper']"
      >
        <span :class="$style['icon-wrapper']">
          <ds-download-icon fill="#8b97ab" />
        </span>
        <div> Przeciągnij i upuść plik tutaj </div>
        <ds-button>
          Wybierz plik
        </ds-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DsFileInput",
  props: {
    name: {
      type: String,
      default: ""
    },
    showError: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedFiles: [],
      fileInside: false
    };
  },
  methods: {
    onChange(e) {
      if (e.target.files.length > 0) {
        if (this.multiple) {
          this.selectedFiles = e.target.files[0];
        } else {
          this.selectedFiles = [e.target.files[0]];
        }

        this.$emit("input", this.selectedFiles);
      }
    },
    onDragEnter() {
      this.fileInside = true;
    },
    onDragLeave() {
      this.fileInside = false;
    }
  }
};
</script>

<style lang="scss" module>
@import "~@theme/scss/_variables.scss";

.header {
  font-weight: 600;
  margin-bottom: 15px;
}

.wrapper {
  padding: 15px;
  background-color: $light-blue-silver-color;
  border-radius: 5px;
  button {
    pointer-events: none !important;
  }
}
.dropbox {
  border: 2px dashed $silver-dark-color;
  background: #fff;
  color: dimgray;
  padding: 10px 10px;
  padding-top: 5px;
  height: 180px;
  position: relative;
  cursor: pointer;
  border-radius: 5px;
  transition: 0.3s;
  &:hover,
  &--active {
    background: rgba(29, 161, 242, 0.2);
  }
}
.input-file {
  opacity: 0;
  width: 100%;
  height: 180px;
  position: absolute;
  cursor: pointer;
}
.no-file-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-weight: 600;
  margin: -10px 0px;
  color: $light-gray-color;
  > * {
    margin: 10px 0px;
  }
  svg {
    width: 45px;
    height: 45px;
  }
}
.icon-wrapper {
  margin-bottom: 0px;
  margin-top: 30px;
}
.file-selected-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  font-weight: 600;
  color: $light-gray-color;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-file-input.vue